// 默认交易所常量
export const TENCENT_SZ = "sz"; // 深交所相关常量
export const TENCENT_SH = "sh"; // 上交所相关常量
export const TENCENT_HK = "hk"; // 港交所相关常量
export const TENCENT_US = "us"; // 美交所相关常量
